import { MILESTONES } from "./data";
import { Reveal, SectionHead } from "./shared";

export default function Milestones() {
  return (
    <section id="milestones" data-testid="milestones-section" className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32">
      <SectionHead
        index="05"
        overline="Milestones"
        title="What this round must produce"
        note="Three deliverables inside 4–6 months. The fourth step is deliberately gated on them."
      />

      <div className="grid grid-cols-1 gap-px overflow-hidden rounded-lg border border-slate-800 bg-slate-800 md:grid-cols-2 lg:grid-cols-4">
        {MILESTONES.map((m, i) => (
          <Reveal key={m.n} delay={i * 0.08} className="h-full">
            <div
              data-testid={`milestone-${m.n}`}
              className={`flex h-full flex-col p-7 ${i === 3 ? "bg-[#14110D]" : "bg-[#0D1320]"}`}
            >
              <span className={`font-mono text-sm ${i === 3 ? "text-amber-500" : "text-[#FF5500]"}`}>{m.n}</span>
              <h3 className="font-display mt-4 text-xl font-semibold uppercase leading-snug tracking-wide text-slate-100">
                {m.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">{m.desc}</p>
              {i === 3 && (
                <span className="mt-auto pt-5 font-mono text-[10px] uppercase tracking-widest text-amber-500/80">
                  Later — gated on traction
                </span>
              )}
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
